/**
 * @description 订单支付界面
 * @param {collectionId: '',saleBatchId: '', code: 活动码 }
 * @returns {/ape/PayPage}
*/
import {Toast} from "antd-mobile";
import React, {useEffect, useRef, useReducer} from "react";
import {useNavigate, useLocation} from "react-router-dom"
import Error from "@/view/Error/index";
import {getPrepayDetail, checkNotpay, getUserInfo, getProductList, getTicketPrepaid, queryPayResult} from '@/api/projectManager_self';
import appService from '@/utils/appService';
import NFTHeader from "@/components/NFTHeader";
import {getUrlAllParams, isIOSNew, isArray} from "@/utils/publicFun";
import {showLoading, hideLoading} from '@/components/loading';
import JsBridgeNew from "@/utils/jsbridgeNew";
import qs from "query-string";

import ShopEditBox from './component/ShopEditBox'
import TotalInfoBox from './component/TotalInfoBox'
import PayTypeSelect from './component/PayTypeSelect'
import BottomBtn from './component/BottomBtn'
import ReturnPoints from "./component/ReturnPoints";

import "./index.scss"

const FromMap = {
  '19': 'cartoon',
  '31': 'boringApe',
  '72': 'workapeBlindbox',
  '77': 'spaceBeautifulAccount',
}

const IdList = ['31', '72', '77', '246'];
const ReturnPointsList = ['31', '72', '204','209', '238', '239','270','342'];
/** 话剧盲盒活动码：仅该活动走 getSimpleProductPrepaid + confirmSimpleOrder */
const isDramaBlindBox = (code) => code === 'dramaBlindBox';

/** 话剧支付结果字段与旧接口不兼容，归一化后再进成功页 */
const normalizeDramaPayResult = (list = []) =>
  (Array.isArray(list) ? list : []).map((item) => ({
    ...item,
    collectionName: item.collectionName || item.name || '',
    nftNo: item.nftNo || (item.num != null ? `×${item.num}` : String(item.id ?? item.goodId ?? '')),
    image: item.image || '',
  }));

/** URL 参数里的图片地址经 qs.stringify 编码，取用时需 decode */
const decodeParamUrl = (url = '') => {
  if (!url) return '';
  try {
    return decodeURIComponent(url);
  } catch {
    return url;
  }
};

/** 话剧预支付数据映射为支付页通用结构 */
const normalizeDramaPayDetail = (info = {}, param = {}) => {
  const maxNum = info.maxNum || 10;
  const stock = info.stock ?? maxNum;
  const price = Number(info.price ?? info.cashPrice ?? info.productPrice);
  return {
    ...info,
    id: info.productId,
    productId: info.productId,
    collectionId: info.productId,
    collectionName: info.productName,
    imageBg: info.imageBg || info.image || decodeParamUrl(param.imageBg) || '',
    price: Number.isFinite(price) ? price : 0,
    defRepeatStr: info.defRepeatStr,
    maxNum,
    pointRatio: info.pointRatio || 0,
    maxPointUse: info.maxPointDed || 0,
    saleBatchInfo: info.saleBatchInfo || {
      saleBatchId: param.saleBatchId || info.saleBatchId || '',
      stock,
      soldDisplay: info.soldDisplay || 0,
      saleStartTime: info.saleStartTime || '2000-01-01 00:00:00',
      saleEndTime: info.saleEndTime || '2099-12-31 23:59:59',
    },
  };
};

const getPurchaseNum = (id) => {
  let num = 10;
  if (id === '19') {
    num = 6;
  } else if (id === '31' || id === '72') {
    num = 5;
  }
  return num;
}

const PayPage = ()=> {
    const navigate = useNavigate()
    //获取参数
    const {search} = useLocation()
    const param = getUrlAllParams(search.slice(1));
    const {
        stock,
        collectionId = '', //藏品id
        saleBatchId = ''
    } = param
    const [state, dispath] = useReducer((state,action)=> {
        //数据处理
        if(JSON.stringify(state) != JSON.stringify(action)) {
            return {
                ...state,
                ...action
            }
        }
        return state
    }, {
        // 设置state初始值
        errorContext:'',
        userInfo: {},
        payDetail:{},
        payType:'',
        salePrice: 0,
        totalPrice: 0,
        count: 1,
        // ios恢复购买开关：codeName 0关闭 1打开
        showRestorePurchase: false,
    });

    const notPayOrder = useRef(false)
    const verifyRealName = useRef(true)
    const h5PayReturnChecked = useRef(false)

    const checkDramaH5PayReturn = async (outTradeNo) => {
        if (!outTradeNo || h5PayReturnChecked.current) return;
        h5PayReturnChecked.current = true;
        try {
            showLoading();
            const { code, msg, data } = await queryPayResult({ outTradeNo });
            hideLoading();
            if (code !== '000000') throw msg;
            if (data) {
                gotoSalePaySuccess(data);
            }
        } catch (error) {
            hideLoading();
            error && Toast.show(error);
        }
    };

    useEffect(()=>{
        if (!collectionId) {
            Toast.show("参数不合法");
            if(process.env.NODE_ENV !== 'development') {
                dispath({errorContext: '参数不合法'})
            }
        } else {
            if (window.JsBridge.hasWebViewBridge()) {
                window.JsBridge.setTitle('订单支付')
                window.JsBridge.verifyRealName("请先实名认证").then((res)=> {
                    verifyRealName.current = !!res?.result
                })
            }
            if (isDramaBlindBox(param.code) && param.payReturn === '1' && param.outTradeNo) {
                checkDramaH5PayReturn(param.outTradeNo);
            }
            loadPageData()
        }

    },[])

    //获取用户信息
    const queryUserInfo = async () => {
        const {code, msg, data} = await getUserInfo();
        if (code !== '000000') throw msg;
        return data;
    }
    //获取支付信息
    const getPayDetail = async () => {
        // 话剧盲盒：预支付走 getSimpleProductPrepaid
        if (isDramaBlindBox(param.code)) {
            const source = window.JsBridge?.hasWebViewBridge?.() ? 'app' : 'h5';
            const {code, msg, data} = await getTicketPrepaid({
                activityCode: 'dramaBlindBox',
                source,
                productId: Number(collectionId) || collectionId,
            });
            if (code !== '000000') throw msg;
            const info = data?.info || data || {};
            return normalizeDramaPayDetail(info, param);
        }
        const params = {
            collectionId: collectionId,
            saleBatchId:saleBatchId,
        };
        const {code, msg, data} = await getPrepayDetail(params);
        if (code !== '000000') throw msg;
        return data;
    }
    //有无待支付订单
    const checkIsHasNotPay = async (collectionType) => {
        const {code, msg, data} = await checkNotpay({collectionType: collectionType || ''});
        if (code !== '000000') throw msg;
        if (data?.notPayOrderCnt) {
            Toast.show("您有待付款的订单，请先完成上次订单")
            notPayOrder.current = true
        }
    }
    // 获取 ios 恢复购买开关（serviceCode 600077，codeName 0关闭 1打开）
    const fetchIosRestorePurchaseSwitch = async () => {
        if (!isIOSNew() || !window.JsBridge?.hasWebViewBridge?.()) return false;
        try {
            const res = await appService('600077', { codeType: 'iosRestorePurchaseSwitch', code: '1' }, false);
            if (!res) return false;
            const result = res?.data?.result ?? res?.result;
            let codeName = result?.defCode?.codeName;
            if (codeName === undefined && Array.isArray(result?.list)) {
                const item = result.list.find(
                    (i) => i?.codeType === 'iosRestorePurchaseSwitch' || i?.code === '1'
                );
                codeName = item?.defCode?.codeName ?? item?.codeName;
            }
            if (codeName === undefined) {
                codeName = result?.defCode?.codeName ?? result?.codeName;
            }
            // 仅当 codeName 明确为 '1' 时显示，其余（含接口失败、异常、未返回）均不显示
            return String(codeName) === '1';
        } catch (e) {
            return false;
        }
    };

    const loadPageData = async () => {
        try {
            showLoading();
            const [userInfo, payDetail, showRestorePurchase] = await Promise.all([
                queryUserInfo(),
                getPayDetail(),
                fetchIosRestorePurchaseSwitch(),
            ]);
            // 话剧预支付无 collectionType，跳过待支付校验
            if (!isDramaBlindBox(param.code)) {
                await checkIsHasNotPay(payDetail?.collectionType);
            }
            hideLoading();
            const unitPrice = Number(payDetail?.price) || 0;
            dispath({
                userInfo: userInfo ||{},
                payDetail: payDetail||{},
                totalPrice: unitPrice,
                count: 1,
                showRestorePurchase: !!showRestorePurchase,
            })

        } catch (error) {
            hideLoading();
            if(process.env.NODE_ENV !== 'development') {
                dispath({errorContext: error})
            }
            Toast.show(error);
        }
    }

    const gotoSalePaySuccess = (list) => {
        const collectionList = isDramaBlindBox(param.code)
          ? normalizeDramaPayResult(list)
          : (list || []);
        if(param.code === 'blindBoxSales'){
          const path = `/blindBox/home`
          const queryParams = {
            collectionList: JSON.stringify(collectionList),
            from: param.code ?? FromMap[collectionId]
        };
          window.JsBridge.replace("CustomWeb", {
            uri: `${window.location.origin}${path}?${qs.stringify(queryParams)}`
        });
        }else{
            navigate(`/ape/PaySuccess`, {
                state: {
                    collectionList,
                    from: param.code ?? FromMap[collectionId],
                },
                replace: true
            })
        }
    }

    const gotoPending = (params) => {
        if(param.code === 'blindBoxSales'){
          const path = `/blindBox/home`
          const queryParams = {
            collectionList: JSON.stringify(params),
            from: param.code ?? FromMap[collectionId]
        };
            window.JsBridge.replace("CustomWeb", {
              uri: `${window.location.origin}${path}?${qs.stringify(queryParams)}`
          });
        }else{
        navigate(`/ape/PaySuccess`, {
            state: {
                pay_query: params,
                from: param.code ?? FromMap[collectionId]
            },
            replace: true
        })
        }

    }

    const gotoOrderList = () => {
        if (window.JsBridge.hasWebViewBridge()) {
            window.JsBridge.replace("Web", {uri: `${window.location.origin}/myGroupOrder`});
        } else {
            navigate(`/myGroupOrder`, {replace: true})
        }

    }

    // 恢复购买功能
    const restorePurchases = async () => {
        if (!window.ReactNativeWebView) {
            Toast.show('当前环境不支持恢复购买');
            return;
        }

        try {
            showLoading();
            
            // 先初始化商品列表（恢复购买需要先初始化商品列表）
            console.log('开始初始化商品列表...');
            const productResult = await getProductList({});
            
            if (productResult.code !== '000000') {
                hideLoading();
                Toast.show(productResult?.msg || '获取商品列表失败');
                return;
            }
            
            if (!productResult.data || !isArray(productResult.data) || productResult.data.length === 0) {
                hideLoading();
                Toast.show('获取苹果支付商品失败');
                return;
            }
            
            // 初始化商品列表到原生端
            console.log('初始化商品列表到原生端:', productResult.data);
            JsBridgeNew.iapProList(JSON.stringify(productResult.data));
            
            // 等待一小段时间确保商品列表初始化完成
            await new Promise(resolve => setTimeout(resolve, 500));

            const callbackName = 'restorePurchasesCallback';
            let timeoutId = null;
            
            // 设置超时处理（30秒）
            timeoutId = setTimeout(() => {
                if (window[callbackName]) {
                    console.warn('恢复购买超时，清理回调函数');
                    delete window[callbackName];
                    hideLoading();
                    Toast.show('恢复购买超时，请稍后重试');
                }
            }, 30000);
            
            // 设置全局回调函数
            window[callbackName] = function(result) {
                // 清除超时
                if (timeoutId) {
                    clearTimeout(timeoutId);
                    timeoutId = null;
                }
                
                hideLoading();
                console.log('恢复购买回调收到结果:', result);
                
                try {
                    // 解析结果 - 支持多种格式
                    let resultData = result;
                    
                    // 如果是字符串，尝试解析
                    if (typeof result === 'string') {
                        try {
                            resultData = JSON.parse(result);
                        } catch (e) {
                            console.error('解析结果失败:', e);
                            resultData = { data: { code: '-1', message: result } };
                        }
                    }
                    
                    console.log('解析后的结果数据:', resultData);
                    
                    // 处理不同的响应格式
                    // 格式1: { status: 1, data: { code: '200', ... } }
                    // 格式2: { data: { code: '200', ... } }
                    // 格式3: { code: '200', ... }
                    const status = resultData.status;
                    const data = resultData.data || resultData;
                    const code = data?.code || resultData.code;
                    
                    if ((status === 1 || status === undefined) && code === '200') {
                        // 恢复成功
                        const restoredCount = data.restoredCount || 0;
                        Toast.show(`恢复成功!恢复了${restoredCount}笔交易`);
                        
                        // 处理恢复的交易
                        const transactions = data.transactions || [];
                        if (Array.isArray(transactions) && transactions.length > 0) {
                            transactions.forEach(transaction => {
                                console.log('恢复产品:', transaction.productId);
                                // 这里可以添加更新购买状态的逻辑
                            });
                        }
                    } else if (code === '0') {
                        // 没有可恢复的购买记录
                        Toast.show('没有可恢复的购买记录');
                    } else {
                        // 恢复失败
                        const errorMsg = data?.message || resultData.message || '恢复失败';
                        console.error('恢复购买失败，错误信息:', errorMsg, '完整结果:', resultData);
                        Toast.show(`恢复失败: ${errorMsg}`);
                    }
                } catch (error) {
                    console.error('恢复购买回调处理错误:', error, '原始结果:', result);
                    Toast.show('恢复购买处理失败，请稍后重试');
                } finally {
                    // 清理回调函数
                    try {
                        delete window[callbackName];
                    } catch (e) {
                        console.error('清理回调函数失败:', e);
                    }
                }
            };

            // 发送消息到原生端
            const message = {
                method: 'iapRestore',
                data: { actionName: callbackName }
            };
            
            console.log('发送恢复购买消息:', message);
            window.ReactNativeWebView.postMessage(JSON.stringify(message));
        } catch (error) {
            hideLoading();
            console.error('恢复购买初始化失败:', error);
            Toast.show('恢复购买初始化失败，请稍后重试');
        }
    }


    const renderBody = ()=> {
        return (
            <div className="pay_page--body">
                <div className="body-content">
                    <ShopEditBox userInfo={state.userInfo}
                        payDetail={state.payDetail}
                        maxCount={isDramaBlindBox(param.code)
                          ? (state.payDetail.maxNum || 10)
                          : getPurchaseNum(collectionId)}
                        showPurchaseMax={!IdList.includes(collectionId)}
                        noDiff={isDramaBlindBox(param.code)}
                        onPriceChange={(totalPrice, count)=> {
                            dispath({
                                count: count,
                                totalPrice: totalPrice
                            })

                        }}
                    />
                    <TotalInfoBox userInfo={state.userInfo}
                        payDetail={{...state.payDetail, count: state.count, totalPrice: state.totalPrice}}/>
                    {
                        (ReturnPointsList.includes(collectionId) && state.payDetail.comicsSet && state.payDetail.pointPercentage) ?
                        <ReturnPoints payDetail={{...state.payDetail, count: state.count, totalPrice: state.totalPrice}}/>
                        : null
                    }
                    <PayTypeSelect onChange={(pay)=>dispath({payType: pay.payType})}/>
                    {
                        // 只在 iOS 且接口开关打开时显示恢复购买按钮（codeName 0关闭 1打开）
                        isIOSNew() && window.JsBridge?.hasWebViewBridge?.() && state.showRestorePurchase && (
                            <div className="restore-purchases-container">
                                <button 
                                    className="restore-purchases-btn"
                                    onClick={restorePurchases}
                                >
                                    恢复购买
                                </button>
                            </div>
                        )
                    }
                </div>
                <div className="bottom">
                    <BottomBtn userInfo={state.userInfo}
                        payDetail={{...state.payDetail, count: state.count, totalPrice: state.totalPrice}}
                        param={param}
                        verifyRealName={verifyRealName.current}
                        notPayOrder={notPayOrder.current}
                        payWay={state.payType}
                        callback={(result) => {
                            if(result.code == 'success') {
                                gotoSalePaySuccess(result.data)
                            }else if((result.code == 'pending')){
                                // 不等待支付结果，直接跳转
                                gotoPending(result.data)
                            }else {
                                gotoOrderList()
                            }
                        }}
                    />
                </div>
            </div>
        )
    }

    return (
        <div className="pay_page">
            {
                !window.JsBridge.hasWebViewBridge() &&
                <NFTHeader midText="订单支付" bgColor="white"/>
            }
            {
               state.errorContext ? <Error context={state.errorContext}/>:
                renderBody()
            }
        </div>
    )
}

export default PayPage;
